import React, { useState, useEffect } from 'react';
import { Modal, Input, ModalFooter, ModalHeader, ModalBody, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

const NewTitleModal = (props) => {
  const { open, onCancel, header, onConfirm, base, intl } = props;
  const [flowTitle, setFlowTitle] = useState('')

  const onChangeTitle = ({ target: { value } }) => {
    setFlowTitle(value)
  }

  const handleOnCopy = () => {
    setFlowTitle('')
    onConfirm(flowTitle)
  }

  useEffect(() => {
    setFlowTitle(`${intl.formatMessage({ id: 'flow.form.title.placeholder', defaultMessage: 'Flow' })} ${base && base.nextFlowIndex}`)
  }, [base])

  return (
    <Modal isOpen={open} centered autoFocus toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{header}</ModalHeader>
      <ModalBody>
        <FormattedMessage id='flows.modal.copy.placeholder' defaultMessage='Title'>
          {placeholder => <Input value={flowTitle} onChange={onChangeTitle} placeholder={placeholder} />}
        </FormattedMessage>
      </ModalBody>
      <ModalFooter>
        <Button color='primary' size="sm" onClick={handleOnCopy} disabled={!flowTitle.trim()}>
          <FormattedMessage id='flows.modal.copy.button' defaultMessage='Copy' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default injectIntl(NewTitleModal);